import React from 'react';
import { makeStyles, GRAY, Box, Typography } from '@applyboard/ui-components';
import { Routes } from "../../Common/Constants";
import Button from "../../Common/FooterButton";
import { HeaderImg } from "../../Common/Images";
import DurationGraphics from "../../Common/DurationGraphics";
import CloseButton from "../../Common/CloseButton/CloseButtonCore";
import useCefNavigation from "../../Hooks/useCefNavigation";
import { useCefEventTracker } from "../../Hooks/useCefEventTracker";
import { CefEvent, CefEventName, Platform } from "../../../../EventTracker";
import { getDescription, getHeader } from "../../Utilities/LanguageHelper";
import { useIsMobile } from "../../Common/useIsMobile";
var useStyles = makeStyles({
  logo: {
    height: '112px',
    width: '112px'
  }
});
var CheckEligibilityIntroContent = function CheckEligibilityIntroContent(_ref) {
  var onExit = _ref.onExit;
  var navigate = useCefNavigation();
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var classes = useStyles();
  var onClick = function onClick() {
    navigate(Routes.Eligibility.NationalityQuestion);
  };
  var onTrackedExit = function onTrackedExit() {
    trackEvent(CefEvent(CefEventName.CancelledEligibilityCheck, Platform.Mobile, {
      step: 'landing page'
    }));
    onExit();
  };
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    p: 5
  }, /*#__PURE__*/React.createElement(Box, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onTrackedExit
  })), /*#__PURE__*/React.createElement(Box, {
    justifyContent: "flex-start",
    mt: "4vh"
  }, /*#__PURE__*/React.createElement(HeaderImg, {
    className: classes.logo
  })), /*#__PURE__*/React.createElement(Box, {
    my: "3vh"
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 500,
      color: GRAY[5]
    },
    variant: "h2"
  }, getHeader())), /*#__PURE__*/React.createElement(DurationGraphics, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    mt: "3vh"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, getDescription())))), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    left: 0,
    bottom: 0,
    position: isMobile ? 'absolute' : 'static'
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Start Eligibility Check",
    onClick: onClick
  })));
};
export default CheckEligibilityIntroContent;